import React from 'react'
import { Box } from '@mui/material'
import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'

import LinkButton from '~/components/Buttons/LinkButton'
import * as ROUTES from '~/constants/routes'

import ActionButtons from './ActionButtons'

import { IFrameStyled } from '../styled/IFrame.styled'

function AutomationRuleStep ({ onSkip }) {
  return (
    <Box>
      <Typography variant="h5" gutterBottom={true}>
        Add your first rule
      </Typography>
      <Box>
        <IFrameStyled
          src="https://www.youtube.com/embed/cuLon2c1eWg"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen={true}
        />
      </Box>
      <ActionButtons onSkip={onSkip}>
        <LinkButton href={ROUTES.AUTOMATION_CREATE_PATH} target="_blank">Add</LinkButton>
      </ActionButtons>
    </Box>
  )
}

AutomationRuleStep.propTypes = {
  onSkip: PropTypes.func.isRequired
}

export default AutomationRuleStep
